module.exports = __webpack_public_path__ + "img/logo.323a7154.jpg";